module.exports = __webpack_public_path__ + "static/media/medic.6cfe2a1c.webp";